import React from 'react'
import { StyledForm } from './style'
import { _FORM_ITEM_LAYOUT, _STRESS_STATE_OPTIONS } from '../../../../../constants';
import { Divider, Form, Input, InputNumber, Select, TimePicker } from 'antd';

interface Props {
  formNum: number;
}

const { Option } = Select;

const DayForm: React.FC<Props> = ({ formNum }) => {
// const [form] = StyledForm.useForm();
// const onFinish = (values: any) => {
//   console.log('Received values of form: ', values);
// };

  return (
    <>
      <Form.Item
        labelAlign="left"
        label="Measurement start time:"
        name={[`form${formNum}`, 'measurementStartTime']}
        rules={[
          {
            required: true,
            message: 'Measurement start time can\'t be blank',
          },
        ]}>
        <TimePicker format="HH:mm" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Duration:"
        name={[`form${formNum}`, 'duration']}
        rules={[
          {
            required: true,
            message: 'Duration can\'t be blank',
          },
        ]}>
        <TimePicker format="HH:mm" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Heart rate:"
      >
        <div>
          <Form.Item
            labelAlign="left"
            label="Low:"
            name={[`form${formNum}`, 'heartRateLow']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Avg:"
            name={[`form${formNum}`, 'heartRateAvg']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="High:"
            name={[`form${formNum}`, 'heartRateHigh']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Stress and recovery balance:"
        name={[`form${formNum}`, 'stressAndRecoveryBalance']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Amount of stress reactions:"
        name={[`form${formNum}`, 'amountOfStressReactions']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Amount of recovery:"
        name={[`form${formNum}`, 'amountOfRecovery']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Recovery during daytime:"
        name={[`form${formNum}`, 'recoveryDuringDaytime']}>
        <TimePicker format="HH:mm" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Restorative effect of sleep:"
        name={[`form${formNum}`, 'restorativeEffectOfSleep']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Length of sleep:"
        name={[`form${formNum}`, 'lengthOfSleep']}>
        <TimePicker format="HH:mm" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Amount of recovered sleep:"
        name={[`form${formNum}`, 'amountOfRecoveredSleep']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Quality of recovery (HRV):"
        name={[`form${formNum}`, 'qualityOfRecovery']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="(MS)" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Self-reported sleep quality"
        name={[`form${formNum}`, 'selfReportedSleepQuality']}
        hasFeedback
      >
        <Select placeholder="Please select">
          <Option value="well">Well</Option>
          <Option value="fairly_well">Fairly Well</Option>
          <Option value="not_well_not_badly">Not Well Not Badly</Option>
          <Option value="fairly_badly">Fairly Badly</Option>
          <Option value="badly">Badly</Option>
        </Select>
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Health effects of physical activity:"
        name={[`form${formNum}`, 'healthEffectsOfPhysicalActivity']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Duration of physical activity:"
      >
        <div>
          <Form.Item
            labelAlign="left"
            label="Light:"
            name={[`form${formNum}`, 'durationOfPhysicalActivityLightTime']}
          >
            <TimePicker format="HH:mm" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Moderate:"
            name={[`form${formNum}`, 'durationOfPhysicalActivityModerateTime']}
          >
            <TimePicker format="HH:mm" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Vigorous:"
            name={[`form${formNum}`, 'durationOfPhysicalActivityVigorousTime']}
          >
            <TimePicker format="HH:mm" style={{ width: '100%' }} />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Total expenditure:"
        name={[`form${formNum}`, 'totalExpenditure']}
      >
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Expenditure by intensity:"
      >
        <div>
          <Form.Item
            labelAlign="left"
            label="Vigorous & moderate:"
            name={[`form${formNum}`, 'expenditureByIntensityVigorousAndModerate']}
          >
            <InputNumber style={{ width: '100%' }} addonAfter="(KCAL)" />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Light:"
            name={[`form${formNum}`, 'expenditureByIntensityLight']}
          >
            <InputNumber style={{ width: '100%' }} addonAfter="(KCAL)" />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Other:"
            name={[`form${formNum}`, 'expenditureByIntensityOther']}
          >
            <InputNumber style={{ width: '100%' }} addonAfter="(KCAL)" />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Number of steps:"
        name={[`form${formNum}`, 'numberOfSteps']}
      >
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Lifestyle assessment score:"
        name={[`form${formNum}`, 'lifestyleAssessmentScore']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="%" />
      </Form.Item>
      <Divider />
      <small>Stress state classification</small>
      <Form.Item
        labelAlign="left"
        label="Alcohol:"
        name={[`form${formNum}`, 'alcohol']}
      >
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Medication:"
        name={[`form${formNum}`, 'medication']}
      >
        <Input style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        name={[`form${formNum}`, 'stressState']}
        labelAlign="left"
        label="Stress state"
        hasFeedback
      >
        <Select placeholder="Please select">
          {_STRESS_STATE_OPTIONS.map((stressState) => (
            <Option key={stressState.value} value={stressState.value}>{stressState.label}</Option>
          ))}
        </Select>
      </Form.Item>
      <Divider />
      <small>Heart Rate Variablity</small>
      <Form.Item
        labelAlign="left"
        label="Average RMSSD:"
      >
        <div>
          <Form.Item
            labelAlign="left"
            label="During awake time (ms):"
            name={[`form${formNum}`, 'averageRmssdDuringAwakeTime']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="During sleep time (ms):"
            name={[`form${formNum}`, 'averageRmssdDuringSleepTime']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Relative difference:"
            name={[`form${formNum}`, 'averageRmssdRelativeDifference']}
          >
            <InputNumber style={{ width: '100%' }} disabled />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Age based minimal score (ms):"
            name={[`form${formNum}`, 'averageRmssdAgeBasedMinimalScore']}
          >
            <Input />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Av RMSSD night / Age based minimum:"
            name={[`form${formNum}`, 'averageRmssdAgeBasedMinimum']}
          >
            <Input />
          </Form.Item>
        </div>
      </Form.Item>
      <Divider />
      <small>Training effect report</small>
      <Form.Item
        labelAlign="left"
        label="Number of reported training events:"
        name={[`form${formNum}`, 'numberOfReportedTrainingEvents']}
      >
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Measurement start time of event:"
        name={[`form${formNum}`, 'measurementStartTimeOfEvent']}
      >
        <TimePicker format="HH:mm" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Duration of event:"
        name={[`form${formNum}`, 'durationOfEvent']}>
        <TimePicker format="HH:mm" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Heart rate for report:"
      >
        <div>
          <Form.Item
            labelAlign="left"
            label="Low:"
            name={[`form${formNum}`, 'heartRateForReportLow']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="Avg:"
            name={[`form${formNum}`, 'heartRateForReportAvg']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="High:"
            name={[`form${formNum}`, 'heartRateForReportHigh']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </div>
      </Form.Item>
      <Divider />
      <small>Training effect event</small>
      <Form.Item
        labelAlign="left"
        label="Type of recovery:"
        name={[`form${formNum}`, 'typeOfRecovery']}
      >
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="EPOC:"
        name={[`form${formNum}`, 'epoc']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="(ml/kg)" />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="Energy expenditure:"
        name={[`form${formNum}`, 'energyExpenditure']}
      >
        <InputNumber style={{ width: '100%' }} addonAfter="(Kcal)" />
      </Form.Item>
    </>
  )
};

export default DayForm;
